import svgUrl from "ni:svgr;vwrTYXJBhstUNqM3luZRTw5ufBMbRjB7Nc62GcQfH_s";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const InnerJoinMIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}><path fill="var(--tbl--colors--icons--transformation--tertiary)" fillRule="evenodd" d="M12 18.93a8 8 0 1 1 0-13.86 8 8 0 1 1 0 13.86Z" clipRule="evenodd" /><path fill="var(--tbl--colors--icons--transformation--primary)" fillRule="evenodd" d="M12 18.93A7.997 7.997 0 0 0 16 12a7.997 7.997 0 0 0-4-6.93A7.997 7.997 0 0 0 8 12a7.997 7.997 0 0 0 4 6.93Z" clipRule="evenodd" /></svg>;
const Memo = memo(InnerJoinMIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "InnerJoinMIcon";
}